import Dispatcher from '../Dispatcher';
import ActionTypes from './ActionTypes';

export default {
  fetch(parentType, parentId) {
    Dispatcher.dispatch({
      actionType: ActionTypes.REPORT_STORE_FETCH,
      parentType,
      parentId,
    });
  }
}
